import { StaffCurrentJourney } from '../../lib/types/models/staff/staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function checkIfStaffIsCurrentlyInJourney(id: number) {
  return restApiClient
    .url(constructApiUrl(API.staffs.checkIfStaffIsCurrentlyInJourney.url, { id }))
    .get<StaffCurrentJourney>()
}
